import { render } from "./ReportSalesByBranch.vue?vue&type=template&id=c4c4f584&scoped=true"
import script from "./ReportSalesByBranch.vue?vue&type=script&lang=js"
export * from "./ReportSalesByBranch.vue?vue&type=script&lang=js"

import "./ReportSalesByBranch.vue?vue&type=style&index=0&id=c4c4f584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c4f584"]])

export default __exports__